import React from 'react';

const PiracyAndMisuseClause = () => {
  return (
    <div className="policy-container">
      <h1>Piracy and Misuse Clause</h1>
      <p>Any user found involved in:</p>
      <ul>
        <li>Sharing login credentials</li>
        <li>Downloading or redistributing course content</li>
        <li>Recording and publishing videos on unauthorized platforms</li>
      </ul>
      <p>will have their account permanently terminated without any refund, and legal action may be pursued.</p>
    </div>
  );
};

export default PiracyAndMisuseClause;
